var chunkToChildrenMap = {
	"3399": [
		5244,
		8070,
		5427,
		4967,
		1551,
		4886
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));